import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export interface GraphNode {
  id: string
  firstName: string
  lastName: string | null
  avatarUrl: string | null
  company: string | null
  jobTitle: string | null
}

export interface GraphEdge {
  id: string
  source: string
  target: string
  relationshipType: string
  strength: number
  sharedInteractions: number
  weight: number
}

export interface RelationshipGraphData {
  nodes: GraphNode[]
  edges: GraphEdge[]
}

export function useRelationshipGraph() {
  return useQuery({
    queryKey: ['relationship-graph'],
    queryFn: () => api<RelationshipGraphData>('/api/relationships/graph'),
  })
}
